export enum AnchorIdsEnum {
  DOMAIN_BLOCK_ANCHOR = 'domain_block_anchor',
  BROWSE_BLOCK_ANCHOR = 'browse_block_anchor',
  FAQ_BLOCK_ANCHOR = 'faq_block_anchor',
  MEDIA_BLOCK_ANCHOR = 'media_block_anchor',
}
